import React, { useState, useEffect, useContext, useRef } from "react";
import quizThumb from '../assets/images/quiz-default.jpg';
import Footer from "../components/footer/Footer";
import SideMenu from "./student/SideMenu";
import Header from "../components/dashboard/header";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { contentContext } from "../context/contentContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import Loader from "../components/loader";
import OpenSeadragon from "openseadragon";
import deepZoom from "../assets/images/icons/Dna-dz.svg";
import Editor from 'react-simple-wysiwyg';

const ViewHistory = ({ }) => {

    let { id } = useParams();
    const location = useLocation();
    const moduleType = location.state?.moduleType;

    const transformRef = useRef(null);
    const viewerRef = useRef(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [cpcQtns, setCpcQtns] = useState(null);
    const [answers, setAnswersData] = useState(null);
    const [qdisplay, setQdisplay] = useState(false);
    const [imageCloudfront, setImg] = useState("");
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [popupImage, setPopupImage] = useState("");
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [img, setImage] = useState("");
    const [popup, setPopup] = useState(false)
    const [casesList, setCasesList] = useState([]);       // final merged list
    const [loader, setLoader] = useState(false);

    const handleClosePopup = () => { setActiveFeedbackModal(false); setFeedBackData({}) };

    const [index, setIndex] = useState(-1);
    const [gallery, setGallery] = useState([]);
    const [currentImage, setcurrentImage] = useState(null);

    // const [isLoading, setIsLoading] = useState(true);

    const [learninguniqueid, setLearninguniqueid] = useState(null);
    const [selected, setSelected] = useState({});
    const [successMsg, setSuccessMsg] = useState(false)
    const [handleBackPopup, setHandleBackPopup] = useState(false)
    const [viewer, setViewer] = useState(null);

    const [dziUrl, setDziUrl] = useState("");
    const [dziUrlFile, setDziUrlFile] = useState("");
    const [dzipopupImage, setDZIPopupImage] = useState(false);

    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [ActiveCaseId, setActiveCaseId] = useState("");

    const [showImagePopup, setShowImagePopup] = useState(false);
    const [activeFeedbackModal, setActiveFeedbackModal] = useState(false);
    const [popupPngImage, setPopupPngImage] = useState("");
    const [feedbackText, setFeedbackText] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const [feedbackLoading, setFeedbackLoading] = useState(false); // NEW

    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [feedBackData, setFeedBackData] = useState({});
    const [quizResultData, setQuizResultData] = useState([]);
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)


    const handleFeedbackChange = (e) => {
        setFeedbackText(e.target.value);
        if (errorMsg) setErrorMsg("");
    };


    // ----------------------
    //  SUBMIT HANDLER
    // ----------------------
    const handleFeedbackSubmit = async () => {
        if (!feedbackText.trim()) {
            setErrorMsg("Feedback is required");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                feedbackDescription: feedbackText,
                moduleid: id,
                caseid: ActiveCaseId,
            };

            const isUpdate = feedBackData && feedBackData._id;
            const res = await tmdbApi.addFeedback(payload, isUpdate);

            // success reset
            setFeedbackText("");
            setErrorMsg("");
            setActiveCaseId("");
            handleClosePopup();
        } catch (err) {
            console.error("Error submitting feedback:", err.response?.data || err.message);
            setErrorMsg("Failed to submit. Try again.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity
        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };
        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });

        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);


    useEffect(() => {
        GetQuizResult();
    }, [])


    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };


    useEffect(() => {
        if (currentImage) {
            const img = new Image();
            img.src = `${imageCloudfront}${currentImage?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`;
            img.onload = () => setIsLoading(false);
        }

    }, [currentImage]);

    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    const handlePopupload = (e) => {
        setPopupLoading(true)
        console.log(dziUrl, "dz")
    }



    const [cancel, setCancel] = useState(false);



    const getFeedbackAPI = async (caseid) => {
        setFeedbackLoading(true);
        try {
            const response = await tmdbApi.getFeedbackApi(caseid, quizResultData?.moduleid, "client");
            if (response?.result) {
                const data = response.result[0] ?? null;
                setFeedBackData(data);
                // setText only after we set the data, to avoid flicker
                setFeedbackText(data?.feedbackDescription ?? "");
            } else {
                setFeedBackData(null);
                setFeedbackText("");
            }
        } catch (err) {
            console.error("getFeedbackAPI error:", err);
            setFeedBackData(null);
            setFeedbackText("");
        } finally {
            setFeedbackLoading(false);
        }
    };

    const GetQuizResult = async () => {
        setLoader(true);
        try {
            const response = await tmdbApi.quizInfo(state?.learninguniqueid);
            const moduleData = response?.result?.[0] || {};
            const allCases = moduleData?.cases || [];

            console.log('all cases', allCases);

            // Process each case to flatten answers with isCorrect property
            const processedCases = allCases.map(singleCase => {
                // Get all answers that have isCorrect property (user's submitted answers)
                const userAnswers = (singleCase.answers || [])
                    .filter(answer => typeof answer.isCorrect === 'boolean');

                // If there are user answers, create entries for each
                if (userAnswers.length > 0) {
                    return {
                        ...singleCase,
                        userAnswers: userAnswers.map((answer, index) => ({
                            ...answer,
                            // Only attach case details to the first answer to avoid duplication
                            caseDetails: index === 0 ? singleCase.caseDetails : "",
                            adminAnswer: singleCase.adminAnswer,
                        }))
                    };
                }

                // If no user answers, return the case as is
                return {
                    ...singleCase,
                    userAnswers: []
                };
            });

            setQuizResultData({
                ...moduleData,
                cases: processedCases
            });

        } catch (err) {
            console.log("error", err);
        } finally {
            setLoader(false);
        }
    };





    const handlePngPopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupPngImage(imageUrl)
    }


    const [videoUrl, setVideoUrl] = useState(null);

    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };



    console.log('moduletypeeeeeeeeeeee', moduleType)

    const handleFeedBackPopup = (item) => {
        setActiveCaseId(item.caseid);
        // clear previous data so UI doesn't show stale values while fetching
        setFeedBackData(null);
        setFeedbackText("");
        setActiveFeedbackModal(true);
        getFeedbackAPI(item.caseid);
    };
    useEffect(() => {
        if (feedBackData) {
            // ensure we only update text if not currently fetching (guard)
            if (!feedbackLoading) {
                setFeedbackText(feedBackData.feedbackDescription ?? "");
            }
        }
    }, [feedBackData, feedbackLoading]);
    return (
        <div id="layout-wrapper" className="module-quiz-db">
            <Header />
            <SideMenu />


            <div className="main-content user-management quiz-page" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-start gap-5">
                                    <div className="flex-grow-1 d-grid gap-2">

                                    </div>
                                    <div className="create-quiz-btn" onClick={() => { navigate("/history/" + id, { state: { moduleType: moduleType } }) }}>
                                        Back
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-between flex-wrap case-main-heading">

                                <div className="col-lg-8 col-md-8 col-12">
                                    <h4 className="mb-2 card-title" id="breadcrumb-title">
                                        {quizResultData?.moduleName}
                                    </h4>
                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: quizResultData?.moduledescription }}></p>

                                </div>
                                {videoUrl && <>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <h2 className="quiz-title">Video</h2>

                                        <div className="video-card">
                                            <img src={videoUrl ? `https://img.youtube.com/vi/${getYouTubeVideoId(videoUrl)}/0.jpg` : `https://img.youtube.com/vi/0.jpg`} alt="Thumbnail" />
                                            <button className="play-btn" >
                                                <span className="material-symbols-outlined" style={{ cursor: "pointer" }}
                                                    onClick={() => setShowVideoPopup(true)}>
                                                    play_arrow
                                                </span>
                                            </button>
                                        </div>

                                    </div>
                                    <div className="cpcquiz-line1"></div>
                                </>}
                            </div>


                        </div>

                        <div className="row table-data">
                            <div className="col-12">
                                <div className="card bg-transparent shadow-none">
                                    <div className="card-body cpc-management p-0 bg-transparent">

                                        <div className="wrapper client_wrapper mt-3 pt-3">
                                            <div className="quiz_page">


                                                <div className="question_block quiz-page p-0 bg-transparent">


                                                    {
                                                        loader ? <Loader /> :
                                                            quizResultData?.cases && (
                                                                <div className="mb-4">
                                                                    {/* {quizResultData.cases.map((caseItem, qIndex) => {


                                                                        const userAnswer = caseItem.answers.find(ans => ans.hasOwnProperty('isCorrect'));
                                                                        const isCorrectAnswer = userAnswer?.isCorrect === true;
                                                                        console.log('caseItem-->', caseItem)
                                                                        return (
                                                                            <div key={qIndex} className="mb-4 case-block admin-case-card">
                                                                                <div className="cpcquiz-ques">
                                                                                    <div className="row justify-content-between align-items-start col-lg-12 quiz-ques-img-case">
                                                                                        <div className="d-flex flex-column col-lg-8 quiz-ques-sect">
                                                                                            <div className="d-flex justify-content-between gap-1 align-items-start mb-2">
                                                                                                <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                    <span className="material-symbols-outlined icon-color">
                                                                                                        assignment
                                                                                                    </span>
                                                                                                    <h2 className="mb-0 admin-case-title" style={{ fontSize: "18px" }}>
                                                                                                        Case {qIndex + 1}
                                                                                                    </h2>
                                                                                                </div>
                                                                                                {moduleType !== "FELLOWSHIP" && (
                                                                                                    <button type="submit" className="border-0 feedback-btn" onClick={(e) => handleFeedBackPopup(caseItem)}>
                                                                                                        <span
                                                                                                            className="feedback-icon material-symbols-outlined"
                                                                                                            style={{ fontSize: "20px" }}
                                                                                                        >feedback

                                                                                                        </span>
                                                                                                       
                                                                                                        Feedback
                                                                                                    </button>)}
                                                                                            </div>
                                                                                            <div className="admin-case-description">
                                                                                                <p className="mb-0" dangerouslySetInnerHTML={{ __html: caseItem?.caseDetails?.clinicalhistory }} />
                                                                                                
                                                                                            </div>
                                                                                            <p className="col-lg-12 quiz-para" dangerouslySetInnerHTML={{ __html: caseItem?.clinicalhistory }} />
                                                                                            <div>

                                                                                                <div className="case-answer-section">
                                                                                                    <div className="question_block p-0 mt-0">
                                                                                                        <div className="result_table cpc-fb-sec-table">



                                                                                                            <div className="">
                                                                                                                <div className="admin-answer-box view-history-pag">




                                                                                                                  
                                                                                                                    {moduleType === "FELLOWSHIP" ?
                                                                                                                        <div className="row py-2 align-items-center">
                                                                                                                            <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                                                <span className="material-symbols-outlined icon-color">
                                                                                                                                    fact_check
                                                                                                                                </span>
                                                                                                                                <div className="fw-semibold admin-answer-heading">
                                                                                                                                    YOUR ANSWER
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-12">
                                                                                                                                <span className="correct">{caseItem?.answers?.[0]?.answer}</span>
                                                                                                                            </div>
                                                                                                                            <div className="col-12"></div>
                                                                                                                        </div>
                                                                                                                        :
                                                                                                                        <>

                                                                                                                            <table className="vh-case-answer-table table table-bordered text-start mt-3">
                                                                                                                                <thead className="table-light">
                                                                                                                                    <tr>
                                                                                                                                        <th className="w-50">Your Answer</th>
                                                                                                                                        <th className="w-50">Actual Answer</th>
                                                                                                                                    </tr>
                                                                                                                                </thead>
                                                                                                                                <tbody>
                                                                                                                                    { }
                                                                                                                                    <tr>

                                                                                                                                        <td className={isCorrectAnswer ? "success correct" : "wrong error"}>
                                                                                                                                            {userAnswer?.answer || "-"}
                                                                                                                                        </td>


                                                                                                                                        <td className="success correct">

                                                                                                                                            {moduleType !== "FELLOWSHIP" ? caseItem?.adminAnswer || "-" : "-"}
                                                                                                                                        </td>
                                                                                                                                    </tr>
                                                                                                                                </tbody>
                                                                                                                            </table>

                                                                                                                        </>


                                                                                                                    }
                                                                                                                </div>

                                                                                                           

                                                                                                                {moduleType === "FELLOWSHIP" && quizResultData?.pathologistSubmitted === true && <>
                                                                                                                    <div className="row mb-3">
                                                                                                                        <div className="col-lg-6 col-12">
                                                                                                                            <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                                                <span className="material-symbols-outlined icon-color">
                                                                                                                                    percent
                                                                                                                                </span>
                                                                                                                                <label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
                                                                                                                                    Marks
                                                                                                                                </label>
                                                                                                                            </div>
                                                                                                                            <div className="col-4 admin-marks-input-wrapper">
                                                                                                                                <input
                                                                                                                                    type="text"
                                                                                                                                    disabled
                                                                                                                                    className={`text-input`}
                                                                                                                                    value={caseItem.marks}
                                                                                                                                    style={{
                                                                                                                                        width: "100%",
                                                                                                                                        padding: "8px 30px 8px 10px",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        fontSize: "14px",
                                                                                                                                    }}
                                                                                                                                />
                                                                                                                                <span className="admin-marks-suffix">
                                                                                                                                  
                                                                                                                                    / %
                                                                                                                                </span>
                                                                                                                            </div>

                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                    <div
                                                                                                                        className="admin-answer-box view-history-pag"
                                                                                                                    >
                                                                                                                        <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                                            <span className="material-symbols-outlined icon-color">
                                                                                                                                fact_check
                                                                                                                            </span>
                                                                                                                            <div className="fw-semibold admin-answer-heading">
                                                                                                                                ACTUAl ANSWER
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                        <div
                                                                                                                            className="correct admin-answer-text"
                                                                                                                        >
                                                                                                                            {caseItem?.adminAnswer}
                                                                                                                        </div>
                                                                                                                    </div>


                                                                                                                    <div className="row">
                                                                                                                        <div className="col-12">
                                                                                                                            <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                                                <span className="material-symbols-outlined icon-color">
                                                                                                                                    notes
                                                                                                                                </span>
                                                                                                                                <label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
                                                                                                                                    Explanation
                                                                                                                                </label>
                                                                                                                            </div>
                                                                                                                            <textarea
                                                                                                                                className={`text-input module-quiz-textarea `}
                                                                                                                                value={caseItem.summary}
                                                                                                                                disabled
                                                                                                                                rows={4}
                                                                                                                                style={{
                                                                                                                                    width: "100%",
                                                                                                                                    padding: "10px 12px",
                                                                                                                                    borderRadius: "4px",
                                                                                                                                    fontSize: "14px",
                                                                                                                                    resize: "vertical",
                                                                                                                                    minHeight: "100px",
                                                                                                                                }}
                                                                                                                            />

                                                                                                                         
                                                                                                                        </div>
                                                                                                                    </div>
                                                                                                                </>
                                                                                                                }
                                                                                                            </div>



                                                                                                        </div>
                                                                                                    </div>



                                                                                                </div>

                                                                                                <div>

                                                                                                </div>








                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-lg-4 quiz-img-section view-history-img-section">
                                                                                            <div className="quiz-img">



                                                                                            </div>
                                                                                            <div className={caseItem?.caseDetails?.files?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>

                                                                                                <div className="d-grid justify-content-start gap-2 align-items-center">
                                                                                                    <div className="img-wrapper">
                                                                                                        {caseItem?.caseDetails?.files && caseItem?.caseDetails?.files.length > 0 && <p className="mt-2">Histological Photos</p>}
                                                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper"> {caseItem?.caseDetails?.files?.map((file, fileIndex) => (
                                                                                                            <div key={fileIndex}

                                                                                                                className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                onClick={(e) => {
                                                                                                                    let filepath = file?.sourcepath || file?.filepath || "";
                                                                                                                    let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                                  
                                                                                                                    setPopupOpen(true);
                                                                                                                    setImageDimensions({ width: file.width, height: file.height });

                                                                                                                    let path = file.dziUrl || "";
                                                                                                                    if (path.startsWith("/")) path = path.slice(1);
                                                                                                                    let isDziURL = path.includes("output.dzi");
                                                                                                                    if (isDziURL) {
                                                                                                                        path = `${path}_files/`;
                                                                                                                        setDziUrl(imageCloudfront + path);
                                                                                                                    } else {
                                                                                                                        setDziUrl(imagePath);
                                                                                                                    }

                                                                                                                    setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                                    setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                                    handlePopupload(e);

                                                                                                                }}
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined img_view">zoom_out_map</span>

                                                                                                                <span className="default-img">

                                                                                                                    <img src={file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (

                                                                                                                        file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                                                    )} alt={file?.originalFilename} />

                                                                                                                </span>
                                                                                                            </div>

                                                                                                        ))}</div>

                                                                                                    </div>

                                                                                                    <div className="img-wrapper">
                                                                                                        {caseItem?.caseDetails?.historyfiles && caseItem?.caseDetails?.historyfiles.length > 0 &&
                                                                                                            <p>Clinical History Photos</p>}
                                                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                            {caseItem?.caseDetails?.historyfiles && caseItem?.caseDetails?.historyfiles.length > 0 && caseItem?.caseDetails?.historyfiles?.map((file, key) => {

                                                                                                                let imagePath = `${imageCloudfront}${file?.sourcepath && file?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                                return (

                                                                                                                    <div
                                                                                                                        key={key}
                                                                                                                        className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                        style={{ width: 'auto' }}
                                                                                                                        onClick={(e) => handlePngPopupImage(imagePath)}
                                                                                                                    >
                                                                                                                        <span className="material-symbols-outlined img_view img-zoom">zoom_out_map</span>
                                                                                                                        <img
                                                                                                                            src={`${imageCloudfront}${file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                                                            alt={`Image ${key + 1}`}
                                                                                                                            loading="lazy"
                                                                                                                        />
                                                                                                                    </div>


                                                                                                                )
                                                                                                            })}
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="cpcquiz-line">
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>

                                                                                    </div>


                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })} */}
                                                                    {quizResultData.cases.map((caseItem, qIndex) => {
                                                                        const userAnswers = caseItem.userAnswers || [];

                                                                        return (
                                                                            <div key={qIndex} className="mb-4 case-block admin-case-card">
                                                                                <div className="cpcquiz-ques">
                                                                                    <div className="row justify-content-between align-items-start col-lg-12 quiz-ques-img-case">
                                                                                        <div className="d-flex flex-column col-lg-8 quiz-ques-sect">
                                                                                            <div className="d-flex justify-content-between gap-1 align-items-start mb-2">
                                                                                                <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                    <span className="material-symbols-outlined icon-color">
                                                                                                        assignment
                                                                                                    </span>
                                                                                                    <h2 className="mb-0 admin-case-title" style={{ fontSize: "18px" }}>
                                                                                                        Case {qIndex + 1}
                                                                                                    </h2>
                                                                                                </div>
                                                                                                {moduleType !== "FELLOWSHIP" && (
                                                                                                    <button type="submit" className="border-0 feedback-btn" onClick={(e) => handleFeedBackPopup(caseItem)}>
                                                                                                        <span
                                                                                                            className="feedback-icon material-symbols-outlined"
                                                                                                            style={{ fontSize: "20px" }}
                                                                                                        >
                                                                                                            feedback
                                                                                                        </span>
                                                                                                        Feedback
                                                                                                    </button>
                                                                                                )}
                                                                                            </div>

                                                                                            <div className="admin-case-description">
                                                                                                <p className="mb-0" dangerouslySetInnerHTML={{ __html: caseItem?.caseDetails?.clinicalhistory }} />
                                                                                            </div>

                                                                                            <p className="col-lg-12 quiz-para" dangerouslySetInnerHTML={{ __html: caseItem?.clinicalhistory }} />

                                                                                            <div>
                                                                                                <div className="case-answer-section">
                                                                                                    <div className="question_block p-0 mt-0">
                                                                                                        <div className="result_table cpc-fb-sec-table">
                                                                                                            <div className="">
                                                                                                                <div className="admin-answer-box view-history-pag">

                                                                                                                    {/* Render based on module type */}
                                                                                                                    {moduleType === "FELLOWSHIP" ? (
                                                                                                                        <div className="row py-2 align-items-center">
                                                                                                                            <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                                                <span className="material-symbols-outlined icon-color">
                                                                                                                                    fact_check
                                                                                                                                </span>
                                                                                                                                <div className="fw-semibold admin-answer-heading">
                                                                                                                                    YOUR ANSWER{userAnswers.length > 1 ? 'S' : ''}
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="col-12">
                                                                                                                                {userAnswers.map((answer, ansIndex) => (
                                                                                                                                    <div key={ansIndex} className="mb-2">
                                                                                                                                        <span className="correct">
                                                                                                                                            {ansIndex + 1}. {answer?.answer}
                                                                                                                                        </span>
                                                                                                                                    </div>
                                                                                                                                ))}
                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    ) : (
                                                                                                                        <>
                                                                                                                            <table className="vh-case-answer-table table table-bordered text-start mt-3">
                                                                                                                                <thead className="table-light">
                                                                                                                                    <tr>
                                                                                                                                        <th className="w-50">Your Answer{userAnswers.length > 1 ? 's' : ''}</th>
                                                                                                                                        <th className="w-50">Actual Answer</th>
                                                                                                                                    </tr>
                                                                                                                                </thead>
                                                                                                                                <tbody>
                                                                                                                                    {userAnswers.length > 0 ? (
                                                                                                                                        userAnswers.map((userAnswer, ansIndex) => {
                                                                                                                                            const isCorrectAnswer = userAnswer?.isCorrect === true;

                                                                                                                                            return (
                                                                                                                                                <tr key={ansIndex}>
                                                                                                                                                    <td className={isCorrectAnswer ? "success correct" : "wrong error"}>
                                                                                                                                                        {userAnswer?.answer || "-"}
                                                                                                                                                    </td>

                                                                                                                                                    {/* Only show admin answer in the first row */}
                                                                                                                                                    {ansIndex === 0 && (
                                                                                                                                                        <td
                                                                                                                                                            className="success correct"
                                                                                                                                                            rowSpan={userAnswers.length}
                                                                                                                                                        >
                                                                                                                                                            {caseItem?.adminAnswer || "-"}
                                                                                                                                                        </td>
                                                                                                                                                    )}
                                                                                                                                                </tr>
                                                                                                                                            );
                                                                                                                                        })
                                                                                                                                    ) : (
                                                                                                                                        <tr>
                                                                                                                                            <td className="wrong error">-</td>
                                                                                                                                            <td className="success correct">
                                                                                                                                                {caseItem?.adminAnswer || "-"}
                                                                                                                                            </td>
                                                                                                                                        </tr>
                                                                                                                                    )}
                                                                                                                                </tbody>
                                                                                                                            </table>
                                                                                                                        </>
                                                                                                                    )}
                                                                                                                </div>

                                                                                                                {/* Fellowship specific sections */}
                                                                                                                {moduleType === "FELLOWSHIP" && quizResultData?.pathologistSubmitted === true && (
                                                                                                                    <>
                                                                                                                        <div className="row mb-3">
                                                                                                                            <div className="col-lg-6 col-12">
                                                                                                                                <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                                                    <span className="material-symbols-outlined icon-color">
                                                                                                                                        percent
                                                                                                                                    </span>
                                                                                                                                    <label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
                                                                                                                                        Marks
                                                                                                                                    </label>
                                                                                                                                </div>
                                                                                                                                <div className="col-4 admin-marks-input-wrapper">
                                                                                                                                    <input
                                                                                                                                        type="text"
                                                                                                                                        disabled
                                                                                                                                        className="text-input"
                                                                                                                                        value={caseItem.marks}
                                                                                                                                        style={{
                                                                                                                                            width: "100%",
                                                                                                                                            padding: "8px 30px 8px 10px",
                                                                                                                                            borderRadius: "4px",
                                                                                                                                            fontSize: "14px",
                                                                                                                                        }}
                                                                                                                                    />
                                                                                                                                    <span className="admin-marks-suffix">/ %</span>
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                        </div>

                                                                                                                        <div className="admin-answer-box view-history-pag">
                                                                                                                            <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                                                <span className="material-symbols-outlined icon-color">
                                                                                                                                    fact_check
                                                                                                                                </span>
                                                                                                                                <div className="fw-semibold admin-answer-heading">
                                                                                                                                    ACTUAL ANSWER
                                                                                                                                </div>
                                                                                                                            </div>
                                                                                                                            <div className="correct admin-answer-text">
                                                                                                                                {caseItem?.adminAnswer}
                                                                                                                            </div>
                                                                                                                        </div>

                                                                                                                        <div className="row">
                                                                                                                            <div className="col-12">
                                                                                                                                <div className="d-flex gap-1 align-items-center mb-2">
                                                                                                                                    <span className="material-symbols-outlined icon-color">
                                                                                                                                        notes
                                                                                                                                    </span>
                                                                                                                                    <label className="fw-semibold mb-0" style={{ fontSize: "14px" }}>
                                                                                                                                        Explanation
                                                                                                                                    </label>
                                                                                                                                </div>

                                                                                                                                {/* Textarea-look HTML container */}
                                                                                                                                <div
                                                                                                                                    className="module-quiz-textarea rich-preview"
                                                                                                                                    style={{
                                                                                                                                        width: "100%",
                                                                                                                                        padding: "10px 12px",
                                                                                                                                        borderRadius: "4px",
                                                                                                                                        fontSize: "14px",
                                                                                                                                        resize: "vertical",
                                                                                                                                        minHeight: "100px",
                                                                                                                                        border: "1px solid #ced4da",
                                                                                                                                        backgroundColor: "#fff",
                                                                                                                                        whiteSpace: "normal"
                                                                                                                                    }}
                                                                                                                                    dangerouslySetInnerHTML={{
                                                                                                                                        __html:
                                                                                                                                            caseItem.summary ||
                                                                                                                                            '<span className="text-muted">No content</span>'
                                                                                                                                    }}
                                                                                                                                />

                                                                                                                                {/* Optional plain text hint */}

                                                                                                                            </div>
                                                                                                                        </div>
                                                                                                                    </>
                                                                                                                )}
                                                                                                            </div>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* Image section remains the same */}
                                                                                        <div className="col-lg-4 quiz-img-section view-history-img-section">
                                                                                            <div className="quiz-img"></div>
                                                                                            <div className={caseItem?.caseDetails?.files?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>
                                                                                                <div className="d-grid justify-content-start gap-2 align-items-center">
                                                                                                    <div className="img-wrapper">
                                                                                                        {caseItem?.caseDetails?.files && caseItem?.caseDetails?.files.length > 0 && (
                                                                                                            <p className="mt-2">Histological Photos</p>
                                                                                                        )}
                                                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                            {caseItem?.caseDetails?.files?.map((file, fileIndex) => (
                                                                                                                <div
                                                                                                                    key={fileIndex}
                                                                                                                    className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                    onClick={(e) => {
                                                                                                                        let filepath = file?.sourcepath || file?.filepath || "";
                                                                                                                        let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`;

                                                                                                                        setPopupOpen(true);
                                                                                                                        setImageDimensions({ width: file.width, height: file.height });

                                                                                                                        let path = file.dziUrl || "";
                                                                                                                        if (path.startsWith("/")) path = path.slice(1);
                                                                                                                        let isDziURL = path.includes("output.dzi");
                                                                                                                        if (isDziURL) {
                                                                                                                            path = `${path}_files/`;
                                                                                                                            setDziUrl(imageCloudfront + path);
                                                                                                                        } else {
                                                                                                                            setDziUrl(imagePath);
                                                                                                                        }

                                                                                                                        setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename);
                                                                                                                        setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                                        handlePopupload(e);
                                                                                                                    }}
                                                                                                                >
                                                                                                                    <span className="material-symbols-outlined img_view">zoom_out_map</span>
                                                                                                                    <span className="default-img">
                                                                                                                        <img
                                                                                                                            src={file?.thumbnailUrl
                                                                                                                                ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150"
                                                                                                                                : (file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom)
                                                                                                                            }
                                                                                                                            alt={file?.originalFilename}
                                                                                                                        />
                                                                                                                    </span>
                                                                                                                </div>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="img-wrapper">
                                                                                                        {caseItem?.caseDetails?.historyfiles && caseItem?.caseDetails?.historyfiles.length > 0 && (
                                                                                                            <p>Clinical History Photos</p>
                                                                                                        )}
                                                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                            {caseItem?.caseDetails?.historyfiles && caseItem?.caseDetails?.historyfiles.length > 0 &&
                                                                                                                caseItem?.caseDetails?.historyfiles?.map((file, key) => {
                                                                                                                    let imagePath = `${imageCloudfront}${file?.sourcepath && file?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`;

                                                                                                                    return (
                                                                                                                        <div
                                                                                                                            key={key}
                                                                                                                            className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                            style={{ width: 'auto' }}
                                                                                                                            onClick={(e) => handlePngPopupImage(imagePath)}
                                                                                                                        >
                                                                                                                            <span className="material-symbols-outlined img_view img-zoom">zoom_out_map</span>
                                                                                                                            <img
                                                                                                                                src={`${imageCloudfront}${file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                                                                alt={`Image ${key + 1}`}
                                                                                                                                loading="lazy"
                                                                                                                            />
                                                                                                                        </div>
                                                                                                                    );
                                                                                                                })
                                                                                                            }
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="cpcquiz-line"></div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                                </div>
                                                            )
                                                    }



                                                    {/* {error.length > 0 && <ErrorList errors={error} />}
                                                    <div className="btns quiz-form-btns">
                                                        <button type="submit" className="create-quiz-btn border-0 mr-10" onClick={(e) => handleSubmit(e)}>Submit</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => onReset(e)}>Reset</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => setCancel(true)}>Cancel</button>
                                                    </div> */}
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                X
                            </span>
                        </button>

                        {/* Zoomable Image */}
                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                {/* <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button> */}
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={popupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                    alt="Popup Image"
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 20px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #dee2e6"
                            }}>
                                <h3 style={{ fontSize: "18px" }}>
                                    {/* {dziUrlFile ? dziUrlFile : ''} */}
                                </h3>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    {/* <button
                                    className="create-quiz-btn border-0"
                                    onClick={resetZoom}
                                >
                                    Reset View
                                </button>
                                <button
                                    onClick={() => rotateImage(90)}
                                    className="create-quiz-btn border-0"

                                >
                                    Rotate 90°
                                </button> */}
                                    {/* <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            border: "none",
                                            fontWeight: "800",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">X</span>
                                    </button> */}
                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            position: "absolute",
                                            top: 10,
                                            right: 10,
                                            cursor: "pointer",
                                            borderRadius: "6px",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>

                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />

                                {/* Instructions */}
                                {/* <div style={{
                                    position: "absolute",
                                    bottom: "20px",
                                    left: "20px",
                                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                                    color: "white",
                                    padding: "10px",
                                    borderRadius: "5px",
                                    fontSize: "12px"
                                }}>
                                    <p style={{ margin: "2px 0" }}>• Zoom with mouse wheel or pinch gesture</p>
                                    <p style={{ margin: "2px 0" }}>• Pan by clicking and dragging</p>
                                    <p style={{ margin: "2px 0" }}>• Use the navigator in the bottom-right for orientation</p>
                                    <p style={{ margin: "2px 0" }}>• Use toolbar buttons to rotate or reset view</p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            )}




            {showImagePopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowImagePopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <img src={popupPngImage} className="modal-img" alt="Popup" />
                        {/* <button
                            onClick={() => setShowImagePopup(false)}
                            className="create-quiz-btn border-0"
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                cursor: "pointer",
                            }}
                        >
                            X
                        </button> */}
                        <button
                            className="dz_close"
                            onClick={() => setShowImagePopup(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                cursor: "pointer",
                                borderRadius: "6px",
                            }}
                        >
                            <span className="material-symbols-outlined">close</span>
                        </button>

                    </div>
                </div>
            )}
            {/* <Modal
                className="access-code-popup"
                show={activeFeedbackModal}
                backdrop="static"
                centered
                onHide={handleClosePopup}
            >
                <Modal.Header closeButton>
                    <Modal.Title> Feedback</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="access-code-body">
                        <div className="form-group feebback-box">
                            {feedbackLoading ? (
                                <>
                                    <div className="p-3 border rounded" style={{ minHeight: 160 }}>
                                        <div>Loading feedback...</div>
                                    </div>
                                    <small className="text-muted d-block mt-2">Fetching feedback mode...</small>
                                </>
                            ) : feedBackData?.status === "ARCHIVE" ? (
                                <>
                                    <p
                                        className="form-control feedback-textarea"
                                        style={{ minHeight: 160, whiteSpace: "pre-wrap", cursor: "default" }}
                                        aria-readonly="true"
                                    >
                                        {feedbackText || "No feedback available."}
                                    </p>
                                    <small className="text-muted d-block mt-2">
                                        This feedback has been reviewed.
                                    </small>
                                </>
                            ) : (
                                <>
                                    <textarea
                                        className="form-control feedback-textarea"
                                        rows="8"
                                        placeholder="Enter your feedback here..."
                                        value={feedbackText}
                                        onChange={handleFeedbackChange}
                                        autoFocus={!feedbackLoading}
                                    />
                                    {errorMsg && (
                                        <span className="errormsg text-danger fw-bold mt-1 d-block">
                                            {errorMsg}
                                        </span>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer
                    className="d-flex justify-content-between modal-footer-custom"
                    style={{ width: "100%" }}
                >
                    {feedbackLoading ? (
                        <div className="w-100 d-flex justify-content-center">
                           
                        </div>
                    ) : feedBackData?.status === "ARCHIVE" ? (
                        <div className="w-100 d-flex justify-content-center">
                            
                        </div>
                    ) : (
                        <>
                            <button className="btn reset-quiz-btn" onClick={handleClosePopup} disabled={loading}>
                                Cancel
                            </button>

                            <button className="btn create-quiz-btn" onClick={handleFeedbackSubmit} disabled={loading}>
                                {loading ? "Submitting..." : (feedBackData ? "Update" : "Submit")}
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal> */}
            <Modal
                className="access-code-popup"
                show={activeFeedbackModal}
                backdrop="static"
                centered
                onHide={handleClosePopup}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Feedback</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="access-code-body">
                        <div className="form-group feebback-box">
                            {feedbackLoading ? (
                                // Loading skeleton / spinner while fetching
                                <>
                                    <div className="p-3 border rounded" style={{ minHeight: 160 }}>
                                        <div>Loading feedback...</div>
                                    </div>
                                    <small className="text-muted d-block mt-2">Fetching feedback mode...</small>
                                </>
                            ) : feedBackData?.status === "ARCHIVE" ? (
                                // Read-only display: render sanitized HTML markup
                                <>
                                    <div
                                        className="form-control feedback-textarea"
                                        style={{ minHeight: 160, cursor: "default", overflow: "auto" }}
                                        aria-readonly="true"
                                        // sanitized HTML injection
                                        dangerouslySetInnerHTML={{ __html: (feedbackText || feedBackData?.description || "No feedback available.") }}
                                    />
                                    <small className="text-muted d-block mt-2">This feedback has been reviewed.</small>
                                </>
                            ) : (
                                // Edit / Add using your rich HTML Editor
                                <>
                                    <div className="feedback-editor-wrapper">
                                        <Editor
                                            name="description"
                                            value={feedbackText}
                                            onChange={handleFeedbackChange}
                                            autoFocus={!feedbackLoading}
                                        />
                                    </div>

                                    {errorMsg && (
                                        <span className="errormsg text-danger fw-bold mt-1 d-block">
                                            {errorMsg}
                                        </span>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer
                    className="d-flex justify-content-between modal-footer-custom"
                    style={{ width: "100%" }}
                >
                    {feedbackLoading ? (
                        // Disable actions while fetching
                        <div className="w-100 d-flex justify-content-center">
                            {/* Optionally show a spinner or disabled message */}
                        </div>
                    ) : feedBackData?.status === "ARCHIVE" ? (
                        // Archived: single Close button
                        <div className="w-100 d-flex justify-content-center">
                            <button className="btn reset-quiz-btn" onClick={handleClosePopup} disabled={loading}>
                                Close
                            </button>
                        </div>
                    ) : (
                        // Default: Cancel + Submit/Update
                        <>
                            <button className="btn reset-quiz-btn" onClick={handleClosePopup} disabled={loading}>
                                Cancel
                            </button>

                            <button className="btn create-quiz-btn" onClick={handleFeedbackSubmit} disabled={loading}>
                                {loading ? "Submitting..." : (feedBackData ? "Update" : "Submit")}
                            </button>
                        </>
                    )}
                </Modal.Footer>
            </Modal>

            {showVideoPopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowVideoPopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <iframe
                            width="100%"
                            height="450"
                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                videoUrl
                            )}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video Preview"
                        ></iframe>
                        <button className="create-quiz-btn"
                            onClick={() => setShowVideoPopup(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            X
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};



export default ViewHistory;